import { useDispatch } from 'react-redux';
import { IFormValues } from 'src/pages/ReviewPage/components/BulkSelectDoc/BulkSelectDoc';
import { IProof } from 'src/ts/interfaces';
import { actions } from '../proofsSlice';

export const useProofUpdateState = () => {
  const dispatch = useDispatch();

  const onCheckProof = (proofId: string, isChecked: boolean) => {
    dispatch(actions.onUpdateCheckProof({ proofId, isChecked }));
  };

  const onCheckProofs = (isChecked: boolean | null) => {
    dispatch(actions.onUpdateCheckProofs({ isChecked: Boolean(isChecked) }));
  };

  const onUpdateLocalProofState = (id: string, formValues: IFormValues) => {
    dispatch(actions.updateLocalProofState({ id, formValues }));
  };

  const getCheckedAll = (proofs: IProof[]) => {
    const unChecked = proofs.length;
    const checked = proofs.filter((proof) => proof.isChecked).length;

    if (checked) {
      if (checked === unChecked) return true;
      if (checked < unChecked) return null;
    }
    return false;
  };

  const getIsLoading = (proofs: IProof[]) => {
    return proofs.filter((proof) => proof.isLoading).length > 0;
  };

  return {
    onCheckProof,
    onCheckProofs,
    getCheckedAll,
    getIsLoading,
    onUpdateLocalProofState
  };
};
